module.exports = __webpack_public_path__ + "img/hx-mp4-bg.ca4f18df.png";